import { createApi } from '@reduxjs/toolkit/query/react'

import { setFlexSettings } from 'core-components/sitebuilder/store/siteBuilderSlice'
import { saveToCache } from 'src/core/classes/cache/Cache'
import StorageKeys from 'src/core/classes/cache/StorageKeys'
import { proxyIdentity } from 'src/core/classes/helpers/UrlHelper'
import { StorageApi } from 'src/core/classes/services/api/StorageApi'
import Logger from 'src/core/utils/Logger'

import { getCustomQuery } from '../helpers/getCustomQuery'

const FLEX_SETTINGS_KEY = 'flexSettingsV2' // TODO: Move to separate store

const storageApi = createApi({
  reducerPath: '@app/api/storageApi',
  baseQuery: getCustomQuery({
    storageKey: StorageKeys.settings,
    baseUrl: proxyIdentity('/mbe/api/v2'),
    cachedUrl: [{ url: '/user/settings', method: 'GET' }],
  }),
  endpoints: (builder) => ({
    fetchSettings: builder.query<any, void>({
      query: () => '/user/settings',
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled
          dispatch(setFlexSettings(data[FLEX_SETTINGS_KEY]?.data || {}))
          const clonedData = structuredClone(data)
          await StorageApi.setDataToStorage(clonedData)
          await saveToCache(StorageKeys.settings, clonedData, true)
        } catch (error) {
          Logger.error(error)
        }
      },
    }),
    setSetting: builder.mutation<any, { key: string; value: any }>({
      query: ({ key, value }) => ({
        url: '/user/settings',
        method: 'PUT',
        body: { [key]: { data: value } },
      }),
      async onQueryStarted({ key, value }, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled
          // Optionally fetch updated settings after set
          await dispatch(storageApi.endpoints.fetchSettings.initiate())
        } catch (error) {
          Logger.error(error)
        }
      },
    }),
  }),
})

export const { useFetchSettingsQuery, useSetSettingMutation } = storageApi
export default storageApi
